var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('announce-items',{attrs:{"items":_vm.data},on:{"click-handler":_vm.clickHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }